/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSInspektorat from '../../models/TSInspektorat';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Inspektorat.
 */
export default class InspektoratRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];

    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public getAllInspektorat(): IPromise<Array<TSInspektorat>> {
        return this.$http.get(this.CONSTANTS.REST_API + 'inspektorat/')
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Inspektoratn REST  object', response.data);
                    return TSInspektorat.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }

    public findInspektorat(inspektoratId: string): IPromise<TSInspektorat | undefined> {
        return this.$http.get(this.CONSTANTS.REST_API + 'inspektorat/' + encodeURIComponent(inspektoratId))
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING TSInspektorat REST  object', response.data);
                    return new TSInspektorat().deserialize(response.data);
                } else {
                    return undefined;
                }
            })

    }

    public createOrUpdate(inspektorat: TSInspektorat): IPromise<TSInspektorat | undefined> {

        if (inspektorat) {
            let restInspektorat: any = inspektorat.serialize({});
            return this.$http.put(this.CONSTANTS.REST_API + 'inspektorat/', restInspektorat)
                .then((response) => {
                    if (response.data !== undefined) {
                        return new TSInspektorat().deserialize(response.data);
                    } else {
                        return undefined;
                    }
                });
        }
        this.$log.error('passed no data, no createOrUpdate request sent');
        return this.$q.when(undefined);

    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/InspektoratRS.rest.ts